import { CheckOutlined, CloseOutlined, DownloadOutlined, FolderOpenTwoTone, ReloadOutlined, SaveOutlined, SendOutlined, UndoOutlined, UploadOutlined } from '@ant-design/icons';
import { getLoaiChamCong, importFileChamCong, lDPhongDuyetChamCong, lDPhuTrachDuyetChamCong, layChamCong, layMauChamCong, luuChamCong, luuTaiLieuChamCong, taiDuLieuChamCongThang, thuHoiChamCong, trinhLDPhongChamCong, xoaChamCong } from "@app/services/chamcong";
import DonViSelectTree from "@pages/utils/DonViSelectTree";
import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Tag, Tooltip, Upload, UploadFile, UploadProps } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { ColumnsType } from 'antd/es/table';
import type { DataNode } from 'antd/es/tree';
import { Select } from 'antd/lib';
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { trangThaiChamCong, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { ChamCongNhanVien, LoaiChamCong, NgayCong } from '../../models/chamcong/ChamCong';
import { ImportFileChamCongRequest } from '../../models/chamcong/FileChamCongRequest';
import { LogNguoiDung } from '../../models/lognguoidung/LogNguoiDung';
import { DataSelectBox } from '../../models/selectbox';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
const { TextArea } = Input;

// Các loại công bắt buộc nhập thêm chú thích khi chấm công
const dsMaLoaiCongCoChuThich = ["H", "CT"];

const laLoaiCongCoChuThich = (maLoaiCong?: string) => {
    return !!maLoaiCong && dsMaLoaiCongCoChuThich.includes(maLoaiCong.toUpperCase());
}

const OChuThichNgayCong = ({ ngayCong }: { ngayCong: NgayCong }) => {
    const [chuThich, setChuThich] = useState<string>(ngayCong?.ghiChu || "");

    useEffect(() => {
        setChuThich(ngayCong?.ghiChu || "");
    }, [ngayCong]);

    return <Input.TextArea
        style={{ marginTop: "2px" }}
        size="small"
        maxLength={500}
        autoSize={{ minRows: 2 }} 
        placeholder="Chú thích"
        title={chuThich}
        value={chuThich}
        onChange={(e) => {
            setChuThich(e.target.value);
            ngayCong.ghiChu = e.target.value;
        }}
    />;
}

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.id,
                title: _item?.tenChucNang,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: convertDataTreeView(_item?.children)
            }
            return rs;
        });
    }
    return chidlrenArr;
}

const columnsDefault: ColumnsType<ChamCongNhanVien> = [
    {
        title: "Họ tên",
        key: "tenNhanVien",
        dataIndex: "tenNhanVien",
        fixed: 'left',
        width: "200px"
    },
    {
        title: "Chức vụ",
        key: "tenChucVu",
        dataIndex: "tenChucVu",
        fixed: 'left',
        width: "150px"
    },
];

const ChamCongThang = () => {
    const [form] = useForm();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [file, setFile] = useState<any>();
    const [isReloadPage, setIsReloadPage] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [idChamCong, setIdChamCong] = useState<number>(0);
    const [idNhanVien, setIdNhanVien] = useState<number>(0);
    const [idDonVi, setIdDonVi] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [dataChamCong, setDataChamCong] = useState<Array<ChamCongNhanVien>>();
    const [tongNgayTrongThang, setTongNgayTrongThang] = useState(0);
    const [dsNgayThuTheoThang, setDSNgayThuTheoThang] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [tableColumns, setTableColumns] = useState<ColumnsType<ChamCongNhanVien>>(columnsDefault);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [traLaiModal, setTraLaiModal] = useState<boolean>(false);
    const [lyDoTraLai, setLyDoTraLai] = useState<string>("");
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [optLoaiCong, setOptLoaiCong] = useState<Array<DataSelectBox>>([]);
    const [listLoaiChamCong, setListLoaiChamCong] = useState<Array<LoaiChamCong>>([]);
    const [logs, setLogs] = useState<Array<LogNguoiDung>>([]);
    const [showDetail, setShowDetail] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const uploadProps: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                const id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa(prev => [...prev, id]);
            }
            setFileList(prev => {
                const index = prev.indexOf(file);
                const next = prev.slice();
                next.splice(index, 1);
                return next;
            });
        },
        beforeUpload: (file) => {
            const maxSize = 20000000;
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList(prev => [...prev, file]);
            }
            return false;
        },
        fileList,
    };
    const menu: any = menuHelper.checkMultiPermission([
        Links.ChamCong.QuanTriChamCongThang,
        Links.ChamCong.ThemChamCong,
        Links.ChamCong.XoaChamCong,
        Links.ChamCong.TrinhChamCong,
        Links.ChamCong.DuyetChamCong,
        Links.ChamCong.LDPhuTrachDuyetChamCong,
        Links.ChamCong.LDPhongDuyetChamCong]);

    const getLoaiCong = async () => {
        var data = await getLoaiChamCong();
        setListLoaiChamCong(data);
        setOptLoaiCong(data.map((x: any) => {
            return {
                "value": x.ma,
                "label": x.ma
            };
        }));
    }

    const taiFileMau = async () => {
        form.validateFields()
            .then(async (values) => {
                try {
                    var response = await layMauChamCong({
                        idDonVi: values.idDonVi,
                        thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                    });
                    let link = document.createElement('a');
                    link.download = `MauChamCong.xlsx`;
                    let blob = new Blob([response.data], { type: response.data.type });
                    link.href = URL.createObjectURL(blob);
                    link.click();
                    URL.revokeObjectURL(link.href);
                } catch (error: any) {
                    toast.error(error || 'Có lỗi xảy ra');
                }
            })
            .catch((values) => { });
    }

    const taiDuLieuChamCong = async () => {
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                var response = await taiDuLieuChamCongThang({
                    idDonVi: values.idDonVi,
                    thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                });
                setDataChamCong(response);
                setDSNgayThuTheoThang(response[0].ngayCong);
                setTongNgayTrongThang(response.length > 0 ? response[0].ngayCong.length : 0);
            } catch (e: any) {
                toast.error(e);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

        });
    }

    const handleFileChange = (files: any) => {
        form.validateFields().then((values) => {
            try {
                if (files.length > 0) {
                    const selectedFile = files[0];
                    if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        setFile(selectedFile);
                    } else {
                        alert("Vui lòng chọn một file Excel (định dạng .xlsx).");
                    }
                }
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
            }

            setShowModal(true);
        }).catch((e) => {
            setShowModal(false);
        });

    };

    const handleUpload = async () => {
        setShowModal(false);
        if (file) {
            form.validateFields().then(async (values) => {
                const formData = new FormData();
                formData.append('file', file);
                var request: ImportFileChamCongRequest = {
                    file: file,
                    idDonVi: values.idDonVi,
                    thangNam: dateCommon.formatDate(values.thang.$d, "MM/yyyy")
                }

                try {
                    var response = await importFileChamCong(request);
                    setDataChamCong(response);
                    setDSNgayThuTheoThang(response[0].ngayCong);
                    setTongNgayTrongThang(response.length > 0 ? response[0].ngayCong.length : 0);
                    toast.success("Import dữ liệu chấm công thành công");
                    setFile(null);
                } catch (error) {
                    setShowModal(false);
                    setFile(null);
                    toast.error("Không thể import file. Vui lòng thử lại sau");
                }
            });
        } else {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
        }
    };

    const renderColumnsTable = async () => {
        const columns: ColumnsType<ChamCongNhanVien> = [...columnsDefault];
        for (var i = 0; i < tongNgayTrongThang; i++) {
            const idx = i;
            columns.push({
                title: () => (
                    <span>
                        {(idx + 1)}<br /> {dsNgayThuTheoThang[idx].thu}
                    </span>
                ),
                key: "ngayCong[" + i + "]",
                align: "center",
                render: (value, record, index) => {
                    const ngaycong = record.ngayCong[idx];
                    if (isDisable || ngaycong?.maLoaiCong == "W") {
                        const tieuDe = ngaycong?.ghiChu ? `${ngaycong?.tenLoaiCong} - ${ngaycong.ghiChu}` : ngaycong?.tenLoaiCong;
                        return <Tooltip title={tieuDe}>
                            <div>
                                {ngaycong?.maLoaiCong == "W" ? <span>&nbsp;</span> : <span>{ngaycong?.maLoaiCong}</span>}
                                {ngaycong?.ghiChu && <div className="hrm-ghichu-chamcong">{ngaycong.ghiChu}</div>}
                            </div>
                        </Tooltip>
                    } else {
                        return <>
                            <Select
                                style={{ width: "100%" }}
                                size="small"
                                disabled={ngaycong?.disable}
                                value={ngaycong?.maLoaiCong}
                                onChange={(v) => {
                                    ngaycong.maLoaiCong = v;
                                    if (!laLoaiCongCoChuThich(v)) {
                                        ngaycong.ghiChu = "";
                                    }
                                    setDataChamCong(prev => [...(prev || [])]);
                                }}
                                options={optLoaiCong}
                            />
                            {laLoaiCongCoChuThich(ngaycong?.maLoaiCong) && <OChuThichNgayCong ngayCong={ngaycong} />}
                        </>;
                    }
                }
            })
        }
        const thongKe: ColumnsType<ChamCongNhanVien> = [];
        thongKe.push({
            title: "HL",
            key: "tongSoCong",
            width: "60px",
            align: "center",
            render: (value, record, index) => {
                let tongHuongLuong = 0;
                record.ngayCong.forEach(ngaycong => {
                    const loaiChamcong = listLoaiChamCong.find(item => item.ma === ngaycong.maLoaiCong);
                    if (loaiChamcong) {
                        tongHuongLuong += loaiChamcong.huongLuong;
                    }
                });
                return <Tooltip title="Ngày công hưởng lương"><span>{tongHuongLuong}</span></Tooltip>
            }
        });
        for (var i = 0; i < listLoaiChamCong.length; i++) {
            const idx = listLoaiChamCong[i];
            if (idx.ma != "W") {
                thongKe.push({
                    title: idx.ma,
                    key: "loaicong[" + i + "]",
                    width: "60px",
                    align: "center",
                    render: (value, record, index) => {

                        let tongMaLoaiCong = 0;
                        record.ngayCong.forEach(ngaycong => {
                            if (idx.ma === ngaycong.maLoaiCong) {
                                tongMaLoaiCong++;
                            } /*else if (idx.ma === "BHXH") {
                                if (ngaycong.maLoaiCong == "TS") {
                                    tongMaLoaiCong++
                                }
                            }*/
                        });
                        return <Tooltip title={idx.ten}><span>{tongMaLoaiCong == 0 ? "-" : tongMaLoaiCong}</span></Tooltip>
                    }
                })
            }
        }
        columns.push({
            title: "Thống kê",
            key: "thongke",
            children: thongKe
        });
        setTableColumns(columns);
    }

    const eventSaveChamCong = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                // ở đây
                var request = {
                    id: idChamCong,
                    idDonVi: values.idDonVi,
                    thangNam: values.thang.$d,
                    nhanVien: dataChamCong
                };
                const data = await luuChamCong(request);
                toast.success("Lưu chấm công thành công.");
                const hasTaiLieu = (idsTaiLieuXoa?.length ?? 0) > 0 || (fileList?.length ?? 0) > 0;
                if (hasTaiLieu) {
                    await luuTaiLieuChamCong({
                        id: data.id,
                        files: fileList,
                        idsTaiLieuXoa: idsTaiLieuXoa
                    });
                }
                setIsReloadPage(true);
                if (idChamCong == 0) {
                    setIdChamCong(data.id);
                    navigate(Links.ChamCong.ChiTietChamCongThang + "?id=" + data.id);
                }
            } catch (error: any) {
                toast.error(error);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const eventThuHoiChamCong = async () => {
        try {
            await thuHoiChamCong(idChamCong);
            toast.success("Thu hồi chấm công thành công.");
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    const eventTrinhLDPhongPheDuyet = async () => {
        try {
            await trinhLDPhongChamCong(idChamCong);
            toast.success("Trình lãnh đạo phòng chấm công thành công.");
            const hasTaiLieu = (idsTaiLieuXoa?.length ?? 0) > 0 || (fileList?.length ?? 0) > 0;
            if (hasTaiLieu) {
                await luuTaiLieuChamCong({
                    id: idChamCong,
                    files: fileList,
                    idsTaiLieuXoa: idsTaiLieuXoa
                });
            }
            setTrangThai(trangThaiChamCong.trinhLDPhong);
            setIsDisable(true);
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    const eventXoaChamCong = async () => {
        try {
            await xoaChamCong(idChamCong);
            toast.success("Xóa thành công.");
            navigate(menu[Links.ChamCong.QuanTriChamCongThang] ? Links.ChamCong.QuanTriChamCongThang : "/");
        } catch (error: any) {
            toast.error(error);
        }
    }

    const eventLDPhongDuyetChamCong = async () => {
        eventLDPhongPheDuyetChamCong(true);
    }

    const eventLDPhongKhongDuyetChamCong = async () => {
        eventLDPhongPheDuyetChamCong(false);
    }

    const eventLDPhongPheDuyetChamCong = async (duyet: boolean) => {
        try {
            await lDPhongDuyetChamCong({
                id: idChamCong,
                isDuyet: duyet,
                lyDo: lyDoTraLai
            });
            toast.success(duyet ? "Trình Lãnh đạo phụ trách thành công." : "Trả lại thành công.");
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error(error);
        }
    }
    const eventLDPhuTrachDuyetChamCong = async () => {
        eventLDPhuTrachPheDuyetChamCong(true);
    }

    const eventLDPhuTrachKhongDuyetChamCong = async () => {
        eventLDPhuTrachPheDuyetChamCong(false);
    }

    const eventLDPhuTrachPheDuyetChamCong = async (duyet: boolean) => {
        try {
            await lDPhuTrachDuyetChamCong({
                id: idChamCong,
                isDuyet: duyet,
                lyDo: lyDoTraLai
            });
            toast.success(duyet ? "Phê duyệt thành công." : "Trả lại thành công.");
            setIsReloadPage(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const layChamCongThang = async (id: number) => {
        try {
            setIsLoading(true);
            var data = await layChamCong(id);
            setIdNhanVien(data.idNVKhoiTao);
            setIdDonVi(data.idDonVi);
            form.setFieldsValue({
                idDonVi: data.idDonVi,
                thang: dayjs(data.thangNam, "MM/YYYY")
            });
            const tongNgay: number = data.nhanVien[0].ngayCong.length > 0 ? data.nhanVien[0].ngayCong.length : 30;
            setTongNgayTrongThang(tongNgay);
            setDSNgayThuTheoThang(data.nhanVien[0].ngayCong);
            setTrangThai(data.trangThai);
            setIsDisable(data.trangThai == trangThaiChamCong.trinhLDPhong || data.trangThai == trangThaiChamCong.trinhLDPhuTrach || data.trangThai == trangThaiChamCong.lDPhuTrachTraLai || data.trangThai == trangThaiChamCong.lDPhuTrachDuyet || user.idDonVi != data.idDonVi);
            setDataChamCong(data.nhanVien);
            setLogs(data.logs);
            if ((data?.dsTaiLieu ?? []).length > 0) {
                var fileHienTai: any = data.dsTaiLieu.map((item: TaiLieu) => {
                    return {
                        uid: item.idTaiLieu + "tailieu",
                        name: item.tenTep,
                        status: 'done',
                        url: urlAdmin + item.duongDan.replace(/\\/g, "/")
                    };
                });
                setFileList(fileHienTai);
            }
        } catch (e) {
            toast.error("Không thể lấy thông tin bảng chấm công");
        }
        setIsLoading(false);
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdChamCong(+id);
        getLoaiCong();
    }, []);

    useEffect(() => {
        if (isReloadPage) {
            if (idChamCong > 0) {
                layChamCongThang(idChamCong);
            }

            setIsReloadPage(false);
        }
    }, [isReloadPage]);

    useEffect(() => {
        if (idChamCong > 0) {
            layChamCongThang(idChamCong);
        }
    }, [idChamCong]);

    useEffect(() => {
        setIsDisable(trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.trinhLDPhuTrach || trangThai == trangThaiChamCong.lDPhuTrachTraLai || trangThai == trangThaiChamCong.lDPhuTrachDuyet);
    }, [trangThai]);

    useEffect(() => {
        renderColumnsTable();
    }, [tongNgayTrongThang, isDisable, optLoaiCong, listLoaiChamCong]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case trangThaiChamCong.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
        case trangThaiChamCong.thuHoi: tag = (<Tag color="warning">Thu hồi</Tag>); break;
        case trangThaiChamCong.trinhLDPhong: tag = (<Tag color="purple">Trình lãnh đạo phòng</Tag>); break;
        case trangThaiChamCong.lDPhongTraLai: tag = (<Tag color="error">Lãnh đạo phòng từ chối</Tag>); break;
        case trangThaiChamCong.trinhLDPhuTrach: tag = (<Tag color="cyan">Trình lãnh đạo phụ trách</Tag>); break;
        case trangThaiChamCong.lDPhuTrachTraLai: tag = (<Tag color="error">Lãnh đạo phụ trách từ chối</Tag>); break;
        case trangThaiChamCong.lDPhuTrachDuyet: tag = (<Tag color="success">Thành công</Tag>); break;
    }

    const showLuuChamCong = (trangThai <= trangThaiChamCong.khoiTao || (trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && user.idDonVi == idDonVi) && menu[Links.ChamCong.ThemChamCong];

    return (
        <section>
            <ContentHeader title="Chấm công tháng" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={
                                <Space>
                                {
                                    trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetChamCong] && <Button
                                        loading={isLoading}
                                        type="primary"
                                        className="hrm-btn-delete"
                                        icon={<CloseOutlined rev="" />}
                                        onClick={() => {
                                                setTraLaiModal(true);
                                        }}
                                    >
                                        Trả lại
                                    </Button>
                                }
                                {
                                    trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetChamCong] && <Button
                                        loading={isLoading}
                                        type="primary"
                                        icon={<CheckOutlined rev="" />}
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Duyệt chấm công",
                                                content:
                                                    <>Bạn có muốn <label> duyệt bảng chấm công</label> này không?</>,
                                                onSubmit: eventLDPhuTrachDuyetChamCong
                                            });
                                        }}
                                    >
                                        Duyệt
                                    </Button>
                                }
                                    {
                                        (trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetChamCong] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setTraLaiModal(true);
                                            }}
                                        >
                                            Trả lại
                                        </Button>
                                    }
                                    {
                                       (trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetChamCong] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Trình LĐ Phụ trách",
                                                    content:
                                                        <>Bạn có muốn <label>trình</label> Lãnh đạo phụ trách duyệt bảng chấm công này không?</>,
                                                    onSubmit: eventLDPhongDuyetChamCong
                                                });
                                            }}
                                        >
                                            Trình LĐ Phụ trách
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.khoiTao || trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && menu[Links.ChamCong.XoaChamCong] && idDonVi == user.idDonVi && <Button
                                            loading={isLoading}
                                            type="primary"
                                            danger
                                            icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Xóa chấm công",
                                                    content: <>Bạn có muốn <label>Xóa</label> bảng chấm công này không?</>,
                                                    onSubmit: eventXoaChamCong
                                                });
                                            }}
                                        >
                                            Xóa
                                        </Button>
                                    }
                                    {
                                        (trangThai == trangThaiChamCong.khoiTao || trangThai == trangThaiChamCong.thuHoi || trangThai == trangThaiChamCong.lDPhongTraLai) && user.idDonVi == idDonVi && menu[Links.ChamCong.TrinhChamCong] && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Trình Lãnh đạo phòng duyệt chấm công",
                                                    content: "Bạn có muốn trình duyệt chấm công hay không?",
                                                    onSubmit: eventTrinhLDPhongPheDuyet
                                                });
                                            }}
                                        >
                                            Trình LĐ phòng
                                        </Button>
                                    }
                                    {
                                        showLuuChamCong && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SaveOutlined rev="" />}
                                            onClick={eventSaveChamCong}
                                        >
                                            Lưu chấm công
                                        </Button>
                                    }
                                    {
                                        // Button thu hồi  chấm công
                                        trangThai == trangThaiChamCong.trinhLDPhong && idDonVi == user.idDonVi
                                        && menu[Links.ChamCong.ThemChamCong] &&
                                        <Button
                                            loading={isLoading}
                                            className="hrm-btn hrm-btn-warning"
                                            icon={<UndoOutlined rev="" />}
                                            onClick={() => {
                                                setConfirmModal({
                                                    isShowModal: true,
                                                    title: "Thu hồi chấm công tháng",
                                                    content:
                                                        <>Bạn có muốn <label>Thu hồi</label> bảng chấm công này không?</>,
                                                    onSubmit: eventThuHoiChamCong
                                                });
                                            }}
                                        >
                                            Thu hồi
                                        </Button>
                                    }
                                </Space>}
                            defaultActiveKey="1"
                            onChange={(key) => {
                                if (key != "1") {
                                    setShowDetail(false);
                                } else setShowDetail(true);
                            }}
                            items={[
                                {
                                    key: "1",
                                    label: "Chấm công tháng",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Form layout="vertical" form={form} validateMessages={validateMessages}>
                                                    <Row guter={[8, 8]}>
                                                        <Col span="8" >
                                                            <Form.Item label="Phòng ban" name="idDonVi" className="pr-1"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}>
                                                                <DonViSelectTree disabled={trangThai > 0} name="idDonVi" donViQuanLy />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="7">
                                                            <Form.Item label="Tháng chấm công" name="thang" className="pl-1"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <DatePicker disabled={trangThai > 0} changeOnBlur={true} style={{ width: "90%" }} placeholder="Tháng chấm công" format={["MM/YYYY", "MMYYYY"]} picker="month"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={9}>
                                                            <Form.Item label="Tài liệu đính kèm">
                                                                <Upload {...uploadProps} disabled={!showLuuChamCong}>
                                                                    {showLuuChamCong && <Button type="primary">
                                                                        <UploadOutlined /> Thêm file
                                                                    </Button>}
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row >
                                                        {
                                                            trangThai <= 3 &&
                                                            <Col span="15">
                                                                <Form.Item label="Chấm công" >
                                                                    <Row>
                                                                        <Space>
                                                                            <Button
                                                                                onClick={taiDuLieuChamCong}
                                                                                type="primary"
                                                                                loading={isLoading}
                                                                                icon={<ReloadOutlined rev="" />}>
                                                                                Tải dữ liệu chấm công
                                                                            </Button>
                                                                            <Button
                                                                                onClick={() => setShowModal(true)}
                                                                                type="primary"
                                                                                loading={isLoading}
                                                                                icon={<UploadOutlined rev="" />}>
                                                                                Import file chấm công
                                                                            </Button>
                                                                            <Button
                                                                                className="hrm-btn-success"
                                                                                onClick={taiFileMau}
                                                                                loading={isLoading}
                                                                                icon=<DownloadOutlined rev="" />
                                                                            >
                                                                                Tải file mẫu
                                                                            </Button>
                                                                        </Space>
                                                                    </Row>

                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                        {
                                                            trangThai >= 0 &&
                                                            <Col span="9">
                                                                <Form.Item label="Trạng thái">
                                                                    <label>{tag}</label>
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                },
                                {
                                    key: '2',
                                    label: "Lịch sử thao tác",
                                    children: <LogNguoiDungTable data={logs} />
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row>
            <div className="card card-primary">
                {
                    showDetail &&
                    <Table
                        loading={isLoading}
                        sticky
                        bordered={true}
                        pagination={false}
                        dataSource={(dataChamCong || []).map((x: any, idx: number) => { x.key = idx; return x; })}
                        //components={tableComponents}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        columns={tableColumns}
                        scroll={{ x: 4500 }}
                    >
                    </Table>      
                }             
            </div>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
            <ModalTextForm
                show={showModal}
                title="Chọn file chấm công"
                handleClose={() => setShowModal(false)}
                handleSave={handleUpload}
            >
                <Dropzone onDrop={handleFileChange} multiple={false}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps()}
                            className="hrm-dropzone-uploadfile"
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Kéo và thả tệp tin ở đây...</p>
                            ) : file ? (
                                <div>
                                    <p>File đã chọn: {file?.name}</p>
                                    <p>Kích thước: {file?.size} bytes</p>
                                </div>
                            ) : (
                                <p>Kéo và thả hoặc chọn một file Excel ở đây.</p>
                            )}
                        </div>
                    )}
                </Dropzone>
            </ModalTextForm>
            {traLaiModal && <ModalTextForm show={traLaiModal}
                title="Trả lại bảng chấm công"
                handleClose={() => {
                    setLyDoTraLai("");
                    setTraLaiModal(false);
                }}
                handleSave={() => {
                    if ((trangThai == trangThaiChamCong.trinhLDPhong || trangThai == trangThaiChamCong.lDPhuTrachTraLai) && menu[Links.ChamCong.LDPhongDuyetChamCong]) {
                        eventLDPhongKhongDuyetChamCong();
                    }
                    if (trangThai == trangThaiChamCong.trinhLDPhuTrach && menu[Links.ChamCong.LDPhuTrachDuyetChamCong]) {
                        eventLDPhuTrachKhongDuyetChamCong();
                    }
                    setLyDoTraLai("");
                    setTraLaiModal(false);
                }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Trả lại</label> bảng chấm công này không? Hãy nhập lý do:
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTraLai} onChange={(e) => {
                            setLyDoTraLai(e.target.value);
                        }} />
                    </Col>
                </Row>
            </ModalTextForm>}
        </section>
    );
};

export default ChamCongThang;
